<!-- eslint-disable -->
<template lang="pug">
    cs-loader(v-if="!params")
    .game-info__individual-settings(v-else)
        multiplayer-tiny-setting.game-info__choose-time(
            :label="`${params.speed} с`",
            :value="params.speed",
            @increase="handleSpeedIncrease",
            @decrease="handleSpeedDecrease",
            :min="seconds[0]",
            :max="seconds[seconds.length - 1]",
            :disabled="!isGamePaused",
        )
        multiplayer-tiny-setting.game-info__difficult(
            :label="`${currentDifficultyValue} Р`",
            :value="currentDifficultyValue",
            :min="difficulties[0].value",
            :max="difficulties[difficulties.length - 1].value",
            :disabled="!isGamePaused",
            @increase="handleDifficultyIncrease",
            @decrease="handleDifficultyDecrease",
        )
        multiplayer-tiny-setting.game-info__actions(
            :label="`${params.amountOfActions} Д`",
            :value="params.amountOfActions",
            :min="amountsOfActions[0]",
            :max="amountsOfActions[amountsOfActions.length - 1]",
            :disabled="!isGamePaused",
            @increase="handleAmountOfActionsIncrease",
            @decrease="handleAmountOfActionsDecrease",
        )
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';
    import AddSubConfig from "../configs/AddSubConfig";

    const PARAMETERS_UPDATE_EVENT = 'parametersUpdate';

    export default {
        mounted () {
            this.parameters = this.paramsArray;
            this.params = this.paramsArray[this.currentUserPosition];
            this.currentDifficultyIndex = this.difficulties.findIndex((difficulty) => {
                return difficulty.name === this.params.difficult;
            });
        },
        props: {
            currentUserPosition: {
                type: Number,
                default: 0,
            },
            isGamePaused: {
                type: Boolean,
                default: false,
            },
            slug: {
                type: String,
                default: 'AdditionAndSubtractionWithTime',
            }
        },
        watch: {
            parameters: {
                handler (value) {
                    if (value && value.length) {
                        this.params = value[this.currentUserPosition];
                    }
                },
                deep: true,
            },
            params: {
                handler (value, oldValue) {
                    if (oldValue !== null) {
                        this.parameters[this.currentUserPosition] = value;
                        this.$store.dispatch('setParamsArray', this.parameters);
                        this.$emit(PARAMETERS_UPDATE_EVENT);
                    }
                },
                deep: true,
            },
            'params.difficult': {
                handler (value) {
                    this.currentDifficultyIndex = this.difficulties.findIndex((difficulty) => {
                        return difficulty.value === value;
                    });
                }
            }
        },
        data () {
            return {
                parameters: null,
                params: null,
                seconds: AddSubConfig.seconds,
                currentDifficultyIndex: 0,
                difficulties: [
                    {
                        label: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                        name: 'Однозначные цифры',
                        $isDisabled: false,
                        value: 1,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        name: 'Двузначные цифры',
                        $isDisabled: false,
                        value: 2,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        name: 'Трехзначные цифры',
                        $isDisabled: false,
                        value: 3,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        name: 'Четырехзначные цифры',
                        $isDisabled: false,
                        value: 4,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                        name: 'Пятизначные цифры',
                        $isDisabled: false,
                        value: 5,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_sixDigitsNum'),
                        name: 'Шестизначные цифры',
                        $isDisabled: false,
                        value: 6,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_sevenDigitsNum'),
                        name: 'Семизначные цифры',
                        $isDisabled: false,
                        value: 7,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_eightDigitsNum'),
                        name: 'Восьмизначные цифры',
                        $isDisabled: false,
                        value: 8,
                    }
                ],
                amountsOfActions: [...Array(101).keys()].slice(2),
            }
        },
        methods: {
            handleSpeedIncrease () {
                this.params.speed = this.seconds[this.seconds.indexOf(this.params.speed) + 1];
            },
            handleSpeedDecrease () {
                this.params.speed = this.seconds[this.seconds.indexOf(this.params.speed) - 1];
            },
            handleDifficultyIncrease () {
                this.currentDifficultyIndex += 1;
                this.params.difficult = this.slug !== 'AnzanWithTime'
                    ? this.difficulties[this.currentDifficultyIndex].name
                    : this.difficulties[this.currentDifficultyIndex].value;
            },
            handleDifficultyDecrease () {
                this.currentDifficultyIndex -= 1;
                this.params.difficult = this.slug !== 'AnzanWithTime'
                    ? this.difficulties[this.currentDifficultyIndex].name
                    : this.difficulties[this.currentDifficultyIndex].value;
            },
            handleAmountOfActionsIncrease () {
                this.params.amountOfActions = this.amountsOfActions[this.amountsOfActions.indexOf(this.params.amountOfActions) + 1];
            },
            handleAmountOfActionsDecrease () {
                this.params.amountOfActions = this.amountsOfActions[this.amountsOfActions.indexOf(this.params.amountOfActions) - 1];
            }
        },
        computed: {
            ...mapState({
                paramsArray: state => state.trainer.paramsArray,
            }),
            currentDifficultyValue () {
                if (this.params) {
                    let difficulty = this.difficulties.find(difficulty => difficulty.value === this.params.difficult);
                    return difficulty ? difficulty.value : 1;
                }
                return 1;
            }
        }
    }
</script>

<style scoped lang="scss">
    .game-info__individual-settings {
        display: flex;
        justify-content: center;
        align-self: center;
    }
</style>